import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import ArticleEditor from './index';

export default (selector, props, show) => {
  let editorInstance;

  const render = (Component) => {
    ReactDOM.render(
      <AppContainer>
        <Component ref={c => { editorInstance = c; }} initProps={props} show={show} />
      </AppContainer>,
      document.querySelector(selector),
    );
  };

  render(ArticleEditor);

  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./index', () => {
      // eslint-disable-next-line global-require
      const NextComponent = require('./index').default;
      render(NextComponent);
    });
  }

  return () => editorInstance;
};



// WEBPACK FOOTER //
// ./app/Assets/js/features/articleEditor/renderInto.js